"use strict";

var _slicedToArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _default = function _default() {
  return {
    name: 'less-than',
    synopsis: 'less-than [NUMBER1] [NUMBER2]',
    description: 'Check whether one number is less than another',
    options: {
      e: {
        description: 'Compare less than or equal to',
        alias: 'or-equal',
        type: 'boolean'
      }
    },
    execute: function execute(args, opts) {
      if (args.length !== 2) throw new Error('Wrong number of arguments');

      var _args = _slicedToArray(args, 2),
          n1 = _args[0],
          n2 = _args[1];

      if (opts.e) {
        return n1 <= n2;
      }

      return n1 < n2;
    }
  };
};

exports.default = _default;